/**
 * Saves a blob as a file via the browser's download mechanism.
 *
 * A plain link (`<a href>` / `window.open`) cannot be used for the exports: it would not send the
 * Authorization header, so the file has to be fetched with HttpClient and saved from memory.
 */
export function downloadBlob(blob: Blob, fileName: string): void {
  const url = window.URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = fileName;
  anchor.style.display = 'none';
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
  // Revoking right away can cancel the download in some browsers, so wait a moment.
  window.setTimeout(() => window.URL.revokeObjectURL(url), 1000);
}

/**
 * Builds a file name from the given parts, e.g. `["Ui-bestandsanalyse", "151193/SAN", "2025-11-23"]`
 * and `"csv"` → `Ui-bestandsanalyse_151193-SAN_2025-11-23.csv`. Characters that are not allowed in
 * file names (e.g. `/` in fund numbers) are replaced, empty parts are skipped.
 */
export function buildFileName(parts: (string | null | undefined)[], extension: string, fallback = 'export'): string {
  const name = parts
    .map(part =>
      (part ?? '')
        .trim()
        .replace(/[\\/:*?"<>|\s]+/g, '-')
        .replace(/^-+|-+$/g, '')
    )
    .filter(part => part.length > 0)
    .join('_');
  return `${name || fallback}.${extension}`;
}
